import dynamic from "next/dynamic";

export const BlogPostingSchema = dynamic(() => import("./component"));
